(() => {
  const mq = window.matchMedia('(max-width: 767px)');
  if (!mq.matches) return;

  let link = null;
  let primary = null;
  let secondary = null;

  let startX = 0;
  let startY = 0;
  let deltaX = 0;
  let width = 0;
  let currentSlide = 0;

  let dragging = false;
  let suppressClick = false;

  const prepare = (target) => {
    link = target.closest('.product-card--featured-image-link');
    if (!link) return false;

    primary = link.querySelector('.product-primary-image');
    secondary = link.querySelector('.product-secondary-image');

    if (!primary || !secondary) return false;

    width = link.getBoundingClientRect().width;
    currentSlide = link.classList.contains('is-swiped') ? 1 : 0;

    secondary.style.display = 'block';

    primary.style.transition = 'none';
    secondary.style.transition = 'none';

    primary.style.transform = `translateX(${-currentSlide * width}px)`;
    secondary.style.transform = `translateX(${(1 - currentSlide) * width}px)`;

    return true;
  };

  document.addEventListener('touchstart', (e) => {
    if (!prepare(e.target)) return;

    const touch = e.touches[0];

    startX = touch.clientX;
    startY = touch.clientY;
    deltaX = 0;

    dragging = false;
    suppressClick = false;
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!link || !primary || !secondary) return;

    const touch = e.touches[0];
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;

    if (!dragging) {
      if (Math.abs(dx) < 6) return;
      if (Math.abs(dy) > Math.abs(dx)) return;

      dragging = true;
      suppressClick = true;
    }

    deltaX = dx;

    /* Petite résistance aux extrémités */
    if (
      (currentSlide === 0 && deltaX > 0) ||
      (currentSlide === 1 && deltaX < 0)
    ) {
      deltaX *= 0.25;
    }

    primary.style.transform =
      `translateX(${(-currentSlide * width) + deltaX}px)`;

    secondary.style.transform =
      `translateX(${((1 - currentSlide) * width) + deltaX}px)`;
  }, { passive: true });

  document.addEventListener('touchend', () => {
    if (!link || !primary || !secondary) return;

    if (!dragging) {
      cleanup();
      return;
    }

    const threshold = Math.min(50, width * 0.18);

    if (deltaX < -threshold && currentSlide === 0) {
      currentSlide = 1;
    } else if (deltaX > threshold && currentSlide === 1) {
      currentSlide = 0;
    }

    primary.style.transition = 'transform .25s ease';
    secondary.style.transition = 'transform .25s ease';

    primary.style.transform =
      `translateX(${-currentSlide * width}px)`;

    secondary.style.transform =
      `translateX(${(1 - currentSlide) * width}px)`;

    link.classList.toggle('is-swiped', currentSlide === 1);

    dragging = false;

    setTimeout(() => {
      if (currentSlide === 0) {
        primary.style.removeProperty('transform');
        primary.style.removeProperty('transition');

        secondary.style.removeProperty('transform');
        secondary.style.removeProperty('transition');
        secondary.style.removeProperty('display');
      }
    }, 260);
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const clickedLink = e.target.closest('.product-card--featured-image-link');

    if (clickedLink && clickedLink === link && suppressClick) {
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  function cleanup() {
    link = null;
    primary = null;
    secondary = null;
    dragging = false;
    deltaX = 0;
  }
})();